import { ActionConfig, ActionContext } from '../../../logic/types'
import { ClaimMarketRewardsAction } from '../types'
import { incentiveControllerAbi } from '@/config/abis/incentiveControllerAbi'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { aaveDataLayerQueryKey } from '@/features/sparklend/common/data/market-info/aave-data-layer/query'

export function createClaimMarketRewardsActionConfig(
  action: ClaimMarketRewardsAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId } = context

  return {
    getWriteConfig: () => {
      return ensureConfigTypes({
        address: action.incentiveControllerAddress,
        abi: incentiveControllerAbi,
        functionName: 'claimAllRewards',
        args: [action.assets, account],
      })
    },

    invalidates: () => [aaveDataLayerQueryKey({ chainId, account }), getBalancesQueryKeyPrefix({ chainId, account })],
  }
}
